import listActions from 'src/modules/sound/list/soundListActions';
import SoundService from 'src/modules/sound/soundService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'SOUND_UNARCHIVE';

const soundUnarchiveActions = {
  UNARCHIVE_STARTED: `${prefix}_UNARCHIVE_STARTED`,
  UNARCHIVE_SUCCESS: `${prefix}_UNARCHIVE_SUCCESS`,
  UNARCHIVE_ERROR: `${prefix}_UNARCHIVE_ERROR`,

  UNARCHIVE_ALL_STARTED: `${prefix}_UNARCHIVE_ALL_STARTED`,
  UNARCHIVE_ALL_SUCCESS: `${prefix}_UNARCHIVE_ALL_SUCCESS`,
  UNARCHIVE_ALL_ERROR: `${prefix}_UNARCHIVE_ALL_ERROR`,

  doUnarchive: (id) => async (dispatch) => {
    try {
      dispatch({
        type: soundUnarchiveActions.UNARCHIVE_STARTED,
      });

      await SoundService.unarchiveAll([id]);

      dispatch({
        type: soundUnarchiveActions.UNARCHIVE_SUCCESS,
      });

      Message.success(
        i18n('entities.sound.unarchive.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/sound');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: soundUnarchiveActions.UNARCHIVE_ERROR,
      });
    }
  },

  doUnarchiveAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: soundUnarchiveActions.UNARCHIVE_ALL_STARTED,
      });

      await SoundService.unarchiveAll(ids);

      dispatch({
        type: soundUnarchiveActions.UNARCHIVE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.sound.unarchiveAll.success'),
      );

      getHistory().push('/sound');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: soundUnarchiveActions.UNARCHIVE_ALL_ERROR,
      });
    }
  },
};

export default soundUnarchiveActions;
